// RENNIK Sticky ATC v6
// Desktop: sticky BOTTOM bar (цена + заглавие + бутон)
// Mobile: sticky BOTTOM bar (цена + бутон, само след като ATC излезе от view)
// Текстовете са locale-aware (html lang) — en/de

function rennikInitStickyATC() {
  var submitBtn = document.querySelector('.product-form__submit');
  if (!submitBtn) {
    setTimeout(rennikInitStickyATC, 300);
    return;
  }

  var isMobile = window.innerWidth < 750;

  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var RKT = lang === 'de'
    ? { add: 'In den Warenkorb', soldOut: 'Ausverkauft', adding: 'Wird hinzugefügt...' }
    : { add: 'Add to cart', soldOut: 'Sold out', adding: 'Adding...' };

  function getPrice() {
    var el = document.querySelector('.price-item--sale, .price-item--regular');
    return el ? el.textContent.trim() : '';
  }
  function getTitle() {
    var el = document.querySelector('.product__title h1');
    return el ? el.textContent.trim() : document.title;
  }
  function isAvailable() { return !submitBtn.disabled; }

  function doAddToCart() { submitBtn.click(); }

  // ── DESKTOP — sticky bottom bar ──
  if (!isMobile) {
    if (document.querySelector('.rennik-desktop-atc')) return;
    var bar = document.createElement('div');
    bar.className = 'rennik-desktop-atc';
    bar.innerHTML =
      '<div class="rennik-desktop-atc__inner">' +
        '<div class="rennik-desktop-atc__info">' +
          '<span class="rennik-desktop-atc__title">' + getTitle() + '</span>' +
          '<span class="rennik-desktop-atc__price">' + getPrice() + '</span>' +
        '</div>' +
        '<button class="rennik-desktop-atc__btn" type="button">' +
          (isAvailable() ? RKT.add : RKT.soldOut) +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);

    var dBtn = bar.querySelector('.rennik-desktop-atc__btn');
    var dPrice = bar.querySelector('.rennik-desktop-atc__price');
    dBtn.disabled = !isAvailable();

    new MutationObserver(function() {
      dBtn.disabled = !isAvailable();
      dBtn.textContent = isAvailable() ? RKT.add : RKT.soldOut;
      dPrice.textContent = getPrice();
    }).observe(submitBtn, { attributes: true });

    // Показваме когато ATC бутонът излезе от view
    new IntersectionObserver(function(entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 1.0 }).observe(submitBtn);

    dBtn.addEventListener('click', function() {
      doAddToCart();
      dBtn.textContent = RKT.adding;
      dBtn.disabled = true;
      setTimeout(function() {
        dBtn.disabled = !isAvailable();
        dBtn.textContent = isAvailable() ? RKT.add : RKT.soldOut;
      }, 1500);
    });
    return;
  }

  // ── MOBILE — цена + бутон, само след ATC излезе от view ──
  if (document.querySelector('.rennik-mobile-atc')) return;
  var mbar = document.createElement('div');
  mbar.className = 'rennik-mobile-atc';
  mbar.innerHTML =
    '<div class="rennik-mobile-atc__inner">' +
      '<div class="rennik-mobile-atc__price-wrap">' +
        '<span class="rennik-mobile-atc__price">' + getPrice() + '</span>' +
      '</div>' +
      '<button class="rennik-mobile-atc__btn" type="button">' +
        (isAvailable() ? RKT.add : RKT.soldOut) +
      '</button>' +
    '</div>';
  document.body.appendChild(mbar);

  var mBtn = mbar.querySelector('.rennik-mobile-atc__btn');
  var mPrice = mbar.querySelector('.rennik-mobile-atc__price');
  mBtn.disabled = !isAvailable();

  new MutationObserver(function() {
    mBtn.disabled = !isAvailable();
    mBtn.textContent = isAvailable() ? RKT.add : RKT.soldOut;
    mPrice.textContent = getPrice();
  }).observe(submitBtn, { attributes: true });

  // Показваме САМО когато сме МИНАЛИ бутона (scrolled past него)
  // НЕ когато е под нас (при зареждане)
  new IntersectionObserver(function(entries) {
    var entry = entries[0];
    if (entry.isIntersecting) {
      // Бутонът е видим — скриваме sticky
      mbar.classList.remove('is-visible');
      document.body.classList.remove('rennik-mobile-bar-active');
    } else {
      // Бутонът не е видим — проверяваме дали е НАД нас (минали сме го)
      // или е ПОД нас (още не сме стигнали)
      var btnRect = submitBtn.getBoundingClientRect();
      var scrolledPast = btnRect.bottom < 0;
      mbar.classList.toggle('is-visible', scrolledPast);
      document.body.classList.toggle('rennik-mobile-bar-active', scrolledPast);
    }
  }, { threshold: 0 }).observe(submitBtn);

  mBtn.addEventListener('click', function() {
    doAddToCart();
    mBtn.textContent = RKT.adding;
    mBtn.disabled = true;
    setTimeout(function() {
      mBtn.disabled = !isAvailable();
      mBtn.textContent = isAvailable() ? RKT.add : RKT.soldOut;
    }, 1500);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', rennikInitStickyATC);
} else {
  rennikInitStickyATC();
}
